import React, { useEffect, useRef, useState } from "react";

const SystemDashboardSection = ({ dashboardImage }) => {
  const imageRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Stop observing once visible
        }
      },
      {
        threshold: 0.6, // Trigger when 60% is in view
      }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);

  return (
    <section className="system-dashboard-section py-5 bg-white">
      <div className="container text-center">
        <h2 className="fw-bold text-dark mb-4 text-uppercase">System Dashboard</h2>
        <img
          ref={imageRef}
          src={dashboardImage}
          alt="System Dashboard"
          className={`img-fluid dashboard-image ${isVisible ? "zoom-in" : ""}`}
        />
      </div>
    </section>
  );
};

export default SystemDashboardSection;
